import { render } from "./OverviewMatingSideNav.vue?vue&type=template&id=32b72ff5"
import script from "./OverviewMatingSideNav.vue?vue&type=script&lang=js"
export * from "./OverviewMatingSideNav.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__